<div class="d-flex flex-column position-relative guest-subscription">
    <button
        mat-icon-button
        mat-dialog-close
        aria-label="Close AWB subscribtion"
        class="position-absolute end-0 top-0 p-0 aling-center"
        (click)="closeModal()"
    >
        <mat-icon>close</mat-icon>
    </button>

    <div class="d-flex align-items-center justify-content-center mt-4 flex-column">
        <app-facility-logo class="mx-auto mt-3" [width]="'140'" [height]="'102'" />
        <div class="d-flex px-4 mt-4 text-center">
            Dear Customer, the <b class="display-contents">MAWB number</b> you have queried has yet to arrive and/or be
            invoiced by {{ facilityName }}. You may wish to contact
            <a [href]="'mailto:{{facilityEmail}}' | sanitize: 'url'" class="display-contents">{{ facilityEmail }}</a>
            or <b class="display-contents">subscribe</b> for an email alert when your cargo/invoice is available.
        </div>
    </div>

    <form [formGroup]="guestSubscriptionForm" class="mt-5">
        <mat-form-field class="col-12">
            <mat-label for="awb">AWB</mat-label>
            <input matInput type="text" formControlName="awb" placeholder="AWB" [appDisableControl]="true" />
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label for="email" class="label-lg text-nowrap">Email</mat-label>
            <input
                matInput
                type="email"
                formControlName="email"
                placeholder="Enter your email"
                id="email-guest-subscription"
            />
            <mat-error>
                <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
            </mat-error>
        </mat-form-field>
        <div class="d-flex align-items-center justify-content-center mt-4">
            <button
                matButton="outlined"
                appMatStrokedButtonBorder
                mat-dialog-close
                color="primary"
                class="me-2"
                (click)="closeModal()"
                [disabled]="subscribing"
            >
                NEW SEARCH
            </button>
            <button matButton="filled" color="primary" (click)="subscribeToAWB()" [disabled]="subscribing">
                CONTINUE
                @if (subscribing) {
                    <mat-icon class="ms-2 spinner-icon" iconPositionEnd>
                        <mat-spinner diameter="16" />
                    </mat-icon>
                }
            </button>
        </div>
    </form>
</div>
